export interface DeviceConfiguration {
  deviceId: string;
  overSpeedingAlarmEnabled: boolean;
}

export interface UpdateDeviceConfiguration {
  deviceId: string;
  speedLimitThresholdInKmh: number;
}

export const MAXIMUM_OVERSPEEDING_THRESHOLD_IN_KMPH = 240;
